export const GET_RELATED_REQUEST = "GET_RELATED_REQUEST";
export const GET_RELATED_REQUEST_SUCCEEDED = "GET_RELATED_REQUEST_SUCCEEDED";
export const GET_RELATED_REQUEST_FAILED = "GET_RELATED_REQUEST_FAILED";
